/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatBmpIcon16Light } from './FileFormatBmpIcon16Light';
import { FileFormatBmpIcon16Regular } from './FileFormatBmpIcon16Regular';
import { FileFormatBmpIcon16Solid } from './FileFormatBmpIcon16Solid';
import { FileFormatBmpIcon20Light } from './FileFormatBmpIcon20Light';
import { FileFormatBmpIcon20Regular } from './FileFormatBmpIcon20Regular';
import { FileFormatBmpIcon20Solid } from './FileFormatBmpIcon20Solid';
import { FileFormatBmpIcon24Regular } from './FileFormatBmpIcon24Regular';
import { FileFormatBmpIcon24Solid } from './FileFormatBmpIcon24Solid';
import { FileFormatBmpIcon32Regular } from './FileFormatBmpIcon32Regular';
import { FileFormatBmpIcon64Regular } from './FileFormatBmpIcon64Regular';
var sizes = {
    16: {
        light: FileFormatBmpIcon16Light,
        regular: FileFormatBmpIcon16Regular,
        solid: FileFormatBmpIcon16Solid,
    },
    20: {
        light: FileFormatBmpIcon20Light,
        regular: FileFormatBmpIcon20Regular,
        solid: FileFormatBmpIcon20Solid,
    },
    24: {
        regular: FileFormatBmpIcon24Regular,
        solid: FileFormatBmpIcon24Solid,
    },
    32: {
        regular: FileFormatBmpIcon32Regular,
    },
    64: {
        regular: FileFormatBmpIcon64Regular,
    },
};
export var FileFormatBmpIcon = forwardRef('FileFormatBmpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
